<template>
    <div>
        <h3>{{$t('instance.instance_details.instance_general.general_title')}}</h3>
        <v-text-field
            v-model="instance.label"
            :label="$t('instance.instance_details.instance_general.instance_field_label')"
            :disabled="true"
            :hint="$t('instance.instance_details.instance_general.instance_field_hint')"
            persistent-hint
        ></v-text-field>
        <v-text-field
            v-model="getCurrentInstanceVersion"
            :label="$t('instance.instance_details.instance_general.modelisation_field_label')"
            :disabled="true"
            :hint="$t('instance.instance_details.instance_general.modelisation_field_hint')"
            persistent-hint
        ></v-text-field>
        <span>
            {{$t('instance.instance_details.instance_general.instance_description')}}
            <v-icon small color="blue">info</v-icon>
        </span>
    </div>
</template>

<script>
export default {

    name: 'general-details',

    props:{
        instance:{
            type: Object,
            required: true,
        },
        modelisations:{
            type: Array,
            required: true,
        },
    },

    data () {
        return {
            selectedVersion: this.modelisations.uid,
        };
    },
    computed:{
        getCurrentInstanceVersion(){
            return `v${this.instance.current_modelisation.version}`;
        }
    },
};
</script>

<style lang="css" scoped>
.general-buttons-content{
    display: flex;
    word-spacing: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceDetails/general-details.vue